// extracted by mini-css-extract-plugin
export var ctaSectionBox = "ctaSection-module--ctaSectionBox--oS6vq";
export var ctaSectionHeadText = "ctaSection-module--ctaSectionHeadText--85aqG";
export var ctaSectionQuizGrid = "ctaSection-module--ctaSectionQuizGrid--8oSC-";
export var ctaSectionSubHeadText = "ctaSection-module--ctaSectionSubHeadText--6D5rs";
export var ctaSectionMediaBox = "ctaSection-module--ctaSectionMediaBox--wUYnH";
export var ctaSectionImg = "ctaSection-module--ctaSectionImg--iwpGq";
export var ctaSectionText = "ctaSection-module--ctaSectionText--qxcIG";
export var actionButtonBox = "ctaSection-module--actionButtonBox--P1FUJ";
export var chooseButtonsBox = "ctaSection-module--chooseButtonsBox--8f+7Q";